export default "__VITE_ASSET__BMg_Kn8y__"